import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

import { submitArticleForm, resetArticleForm, setArticleForm } from '../../../../store/modules/articles/actions';
import { selectArticleForms, selectArticleForm } from '../../../../store/modules/articles/selectors';

type Props = {
  id: number;
};

const MediaFormProvider = ({ id }: Props) => {
  const dispatch = useDispatch();
  const form = useSelector(selectArticleForm(id));
  const { isSubmit, isReset } = useSelector(selectArticleForms);
  const {
    dirty, isValid, isSubmitting, submitForm, resetForm,
  } = useFormikContext();

  useEffect(() => {
    const changeForm = {
      id,
      isChange: dirty,
      isValid,
    };

    if (isSubmit && dirty && form && !isSubmitting) {
      dispatch(submitArticleForm({
        callback: submitForm,
        id,
      }));
    }

    if (isReset && form) {
      dispatch(resetArticleForm({
        callback: resetForm,
        id,
      }));
    }

    if (!isSubmit && !isReset && !isSubmitting) {
      if (!form && dirty) {
        dispatch(setArticleForm(changeForm));
      } else if (form) {
        if (form.isChange !== dirty || form.isValid !== isValid) {
          dispatch(setArticleForm(changeForm));
        }
      }
    }
  }, [id, dispatch, form, isSubmit, isSubmitting, isReset, dirty, isValid, submitForm, resetForm]);

  return null;
};

export default MediaFormProvider;
